/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import FormInputs from "../../FormInputs";
import {getCmsStepInfos, updateCmsStep, uploadCmsStepImage} from "../../../api/admin/cmsReq";
import useAuth from "../../../hooks/useAuth";
import {useNavigate, useParams} from "react-router-dom";
import useData from "../../../hooks/useData";
import {
    checkRequiredFields,
    fileToBase64,
    getErrorListFromValidation,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import FormButtons from "../../../components/common/FormButtons";
import Icon from "../../../components/common/Icon";


export default function FormCms({ setShowModal, apiCmsStep }) {

    const { auth } = useAuth();
    const token = auth?.token;
    const { id } = useParams();
    const { cmsStepInfos, setCmsStepInfos, htmlInputContent} = useData();
    const navigate = useNavigate();
    const [values, setValues] = useState();
    const imageFolder = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const [ selectedImage, setSelectedImage ] = useState();

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e);
    };

    const apiCmsStepInfos = async () => {
        const response = await getCmsStepInfos(token, id);
        setCmsStepInfos(response);
    }

    useEffect(() => {
        if (id != 0) {
            setValues(cmsStepInfos)
        }
    }, [ cmsStepInfos ])

    useEffect(() => {
        apiCmsStepInfos();
    }, [ id ]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(id),
            title : values?.title,
            description : values?.description,
            important : values?.important,
            content : values?.content,
            status : parseInt(values?.status),
            category : parseInt(values?.category),
            shortTitle : values?.shortTitle,
            route : values?.route,
            seoTitle : values?.seoTitle,
            seoMeta : values?.seoMeta,
            seoIndex : values?.seoIndex  == "on" ? true : false,
            imageName : values?.imageName,
            number : parseInt(values?.number)
        }
        await updateCmsStep(token, body, id)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false);
                    apiCmsStep();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error);
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false);
        navigate("/admin/cms/demarches")
    };

    const apiUploadedFile = async() => {
        let fileName = values?.imageName;
        let fileType = "imageName";

        const formData = new FormData();
        formData.append('file', base64String);
        formData.append('file_type', fileType);
        formData.append('number', values?.number);
        if (fileType === "imageName") {
            fileName = values?.imageName
        }
        formData.append('file_name', fileName);
        const response = await uploadCmsStepImage(token, formData, id)
            .then((response) => {
                setValues({...values, imageName : response?.file_name})
            })
    }
    const [ base64String, setBase64String ] = useState(null);

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result)
        }
        reader.readAsDataURL(selectedFile)
        try {
            const base64StringConst = await fileToBase64(selectedFile);
            setBase64String(base64StringConst)
            setValues({...values, imageName : selectedFile?.name})
        } catch (error) {
            console.error("Erreur lors de la conversion en base64 : ", error);
        }
    };

    useEffect(() => {
        const newValues = { ...values };

        for (const key in htmlInputContent) {
            if (htmlInputContent.hasOwnProperty(key)) {
                newValues[key] = htmlInputContent[key];
            }
        }
        setValues(newValues);
    }, [ htmlInputContent]);

    const handleFileUpload = (e) => {
        if (base64String) {
            apiUploadedFile()
        } else {
            alert("Veuillez sélectionner un fichier à envoyer.")
        }
    };

    const handleHtmlContent = (e, inputName) => {
        setValues({...values, [inputName] : e})
    };


    const inputs = [
       {
            id : 1,
            name : "title",
            type : "html",
            placeholder : "Titre de l'article",
            label : "Titre de l'article",
            pattern : "^[a-zA-ZÀ-ÿ0-9_ ]*$",
            required : true,
            content : values?.title,
       },
       {
            id : 2,
            type : "html",
            name : "description",
            placeholder : "Description de l'article",
            label : "Description de l'article",
            required : true,
            content: values?.description,
       },
       {
            id: 3,
            type: "html",
            name: "important",
            label: "Points importants",
            placeholder: "Points importants",
            required: true,
            content: values?.important,
       },
        {
            id : 12,
            name : "number",
            type : "number",
            placeholder : "Numéro d'article",
            label : "Numéro d'article",
            required: true,
       },
       {
            id : 13,
            name : "category",
            type : "select",
            options :
                [
                    {"": "Choisir une catégorie"},
                    {"1": "Inhumation"},
                    {"2": "Crémation"}
                ],
            selected : values?.category,
            placeholder : "Catégorie de l'article",
            label : "Catégorie de l'article",
            required: true,
       },
       {
            id : 5,
            name : "status",
            type : "text",
            placeholder : "Statut de publication",
            label : "Statut de publication",
            required: true,
       },
       {
            id : 6,
            name : "shortTitle",
            type : "textarea",
            placeholder : "Short title",
            label : <span>Short title<br/>Titre affiché dans les menus</span>,
       },
        {
            id : 7,
            name : "route",
            type : "textarea",
            placeholder : "Route",
            label : <span>Route<br/>URL affichée dans la barre d'adresse</span>,
            required: true,
        },
        {
            id : 8,
            name : "seoTitle",
            type : "textarea",
            placeholder : "Titre SEO",
            label : <span>Titre SEO<br/>Titre de la page pour les moteurs de recherche</span>,
        },
        {
            id : 9,
            name : "seoMeta",
            type : "textarea",
            placeholder : "Meta SEO",
            label : <span>Meta SEO<br/>Description de la page pour les moteurs de recherche</span>,
        },
        {
            id : 10,
            name : "seoIndex",
            type : "checkbox",
            placeholder : "Index SEO",
            label : <span>Index SEO<br/>Cocher pour indexer la page</span>,
        },
        {
            id : 14,
            name : "content",
            type : "html",
            placeholder : "Contenu",
            label : "Contenu",
            required: true,
            content : values?.content,
        },
        {
            id : 11,
            type : "file",
            name : "imageName",
            label : "Illustration de l'étape",
            placeholder : "Illustration de l'étape",
            image : `${imageFolder}/img/etapes/${values?.imageName}`,
            file_type : "imageName",
        },
    ];

    return(
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                <Icon span={id == 0 ? "Ajout d'une démarche" : "Modification d'une démarche"} source="fa fa-list" />
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={values?.[input.name]}
                        onChange={onChange}
                        onChangeHtml={(e) => handleHtmlContent(e, input.name)}
                        required={input.required}
                        options={input.options}
                        selected={input.selected}
                        checked={input.checked}
                        multiple={input.multiple}
                        key={input.id + input.name}
                        pattern={input.pattern}
                        handleFileUpload={handleFileUpload}
                        handleFileChange={handleFileChange}
                        content={input.content}
                        className={input.className}
                    />
                ))}
                { selectedImage &&
                    <img src={selectedImage} />
                }
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    );
}